import React from "react"
import styled from "styled-components"
import { MaxWidthContainer } from "../layout"
import RomanceItem from "./romance-item"

const Container = styled(MaxWidthContainer)``

const RomanceList = ({ romanceItems, setCurrentSection }) => {
    return (
        <Container>
            {romanceItems.map((item, index) => (
                <RomanceItem
                    key={index}
                    id={`${item.title[0]}-${index}`}
                    item={{ ...item, id: `${item.title[0]}-${index}` }}
                    odd={index % 2 === 1}
                    setCurrentSection={setCurrentSection}
                />
            ))}
        </Container>
    )
}

export default RomanceList
